import styled from "@emotion/styled";
import { GrBox, GrEmpty, GrEmptyProps, GrStack } from "@jnpmedi/grebob";
import { MvnMessage } from "@newLibs/utils";
import { DOCS_FOLDER_LANG } from "@maven-msg/lang/docs";

interface NotFoundViewProps {
  title?: string;
  description?: string;
  type?: GrEmptyProps["type"];
}

export function NotFoundView({
  title = MvnMessage(DOCS_FOLDER_LANG.DOCS_NO_FOLDER_WARN_TITLE),
  description = MvnMessage(DOCS_FOLDER_LANG.DOCS_NO_FOLDER_WARN_DESCRIPTION),
  type = "simple",
}: NotFoundViewProps) {
  return (
    <StyledErrorContainer>
      <GrStack gap={16} flexDirection="column" justifyContent="normal" alignItems="center">
        <StyledErrorEmpty type={type} title={title} description={description} />
      </GrStack>
    </StyledErrorContainer>
  );
}

const StyledErrorContainer = styled(GrBox)(({ minHeight = 400 }: { minHeight?: number }) => ({
  minHeight: minHeight,
  height: "496px",
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
  boxSizing: "border-box",
  paddingTop: "20px",
  paddingBottom: "20px",
  paddingLeft: "8px",
  paddingRight: "8px",
}));

const StyledErrorEmpty = styled(GrEmpty)({
  "> *": {
    wordBreak: "break-word",
    whiteSpace: "pre-wrap",
    textAlign: "center",
    lineHeight: 1.6,
  },
});
